/**
 * This constant contains the fields of a contact that are sent to a custom audience.
 * 
 * If any of this fields is updated its required to update that contact for its synced
 * custom audiences.
 */

 export const FB_CUSTOM_AUDIENCE_FIELDS = {
   contactFields: [
    'first_name',
    'last_name',
    'email',
    'mobile_phone',
  ],
  addressFields: [
    'zip',
    'city',
    'state',
  ]
};
